import { Badge, Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import ProfilePicture from "ProfilePictures/LuisFernandoRamos.jpg";

const LuisFernandoRamos: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <div className='mb-2 text-center'>
        <div className='mb-2 d-flex flex-row align-items-center justify-content-center'>
          <h2>Luis</h2>
          <img
            className='rounded-circle m-4'
            width={92}
            alt='Foto de perfil Luis Fernando Ramos'
            height={92}
            src={ProfilePicture}
          />
          <h3 className='text-muted'>QA Tester Jr.</h3>
        </div>
      </div>
      <div className='mt-4 text-center'>
        <h4>Breve biografía</h4>
        <p className='text-muted'>
          A la fecha (16/07/2021) tengo apenas 34 años, soy de Goya Corrientes y
          vivo en Santa Fe desde el año 2005 cuando me vine a estudiar la
          carrera de Bioquímica en la Facultad de Biología y Ciencias Biológicas
          (UNL). No finalacé la carrera porque era necesario empezar a trabajar
          y fue así que me desempeñé como administrativo en una Obra Social
          Sindical por largos 9 años 6 meses.
          <br />
          Lo mejor de mi paso por la Facu fueron materias como Análisis
          Matemático, Espectroscopía Molecular, Fisicoquímica, Física, Métodos
          Matemáticos aplicados a Química y Biología y Química Cuántica,
          difíciles pero realmente emocionantes.
          <br />
          Soy casado y vivo con mi esposa Edith, y mi hija Ana Clara de 4 años.
          <br />
          Me gusta la música, tocar la guitarra, y compartir con amig@s.
        </p>
      </div>

      <div className='mt-4 text-center'>
        <h4>Mis comienzos</h4>
        <p className='text-muted'>
          Cuando inicié con la programación inicié con Pseudocódigo y con LPP
          (lenguaje de programación para principiante). Luego Javascript, HTML y
          CSS a través del sitio{" "}
          <a href='https://developer.mozilla.org/es/'>MDN Web Docs</a>. Mi
          primer editor: <a href='http://brackets.io/'>Bracket</a>. En la
          búsqueda de elegir entre Frontend o Backend continué con Ruby y Ruby
          on Rails. Para mi, Ruby on Rails es increíble y fue de la mano de{" "}
          <a href='https://rubyonrails.org/'>Rails</a> que conocí la metodología
          TDD y las pruebas automatizadas con gemas como{" "}
          <a href='https://rspec.info/'>RSpec</a>,{" "}
          <a href='https://github.com/thoughtbot/shoulda-matchers'>
            Shoulda Matchers
          </a>
          , <a href='https://github.com/thoughtbot/factory_bot'>Factory Bot</a>,{" "}
          <a href='https://github.com/DatabaseCleaner/database_cleaner'>
            Database Cleaner
          </a>
          , <a href='https://github.com/faker-ruby/faker'>Faker</a>.<br />
          Luego realicé prácticas con{" "}
          <a href='https://www.heroku.com/home'>Heroku</a> y sitios que han
          quedados inconclusos como ser una{" "}
          <a href='https://murmuring-crag-83663.herokuapp.com/'>Red Social</a> y
          un <a href='https://frozen-mountain-25282.herokuapp.com/'>Blog</a>.{" "}
          <br />
        </p>

        <p className='text-muted'>
          Luego está el{" "}
          <a href='https://fernanluis.github.io/'>sitio estático</a>, alojado en
          el repositorio de GitHub Pages, realizado con un generador de sitios
          estáticos llamado{" "}
          <a href='https://docs.getpelican.com/en/4.6.0/quickstart.html'>
            Pelican
          </a>{" "}
          y el motor de plantilla Jinja2.
          <br />
          El <a href='http://www.pelicanthemes.com/'>Theme</a> elegido fué{" "}
          <a href='https://github.com/petrnohejl/MinimalXY/tree/87f0ebb57543b7810dffc9ebe05ed96bc897ffd1'>
            MinimalXY Pelican Theme
          </a>
          . El sitio cuenta con integraciones como{" "}
          <a href='https://analytics.google.com/analytics/web/provision/#/provision'>
            Google Analytics
          </a>
          , <br />
          <a href='https://disqus.com/'>Discus</a>,{" "}
          <a href='https://www.inspectlet.com/?gclid=Cj0KCQjw_8mHBhClARIsABfFgpik__bsMbchNvUq7evfOqHNEmLJU3lTksNHSStjQyU16x4vOY6uXVoaAsBuEALw_wcB'>
            Inspectlet
          </a>
          . También cuenta con plugins como Tiempo de lectura, acortador de de
          URLs, SEO, Multilenguaje.
          <br />
          Algo más emocionante aún fue CI/CD con Github Actions, y gestión de
          contenido con Headless CMS llamado Prose.
        </p>
      </div>

      <div className='mt-4 text-center'>
        <p className='text-muted'>
          Favoritos:{" "}
          <Badge className='mr-2' variant='primary'>
            Java
          </Badge>
          <Badge className='mr-2' variant='danger'>
            Ruby on Rails
          </Badge>
          <Badge className='mr-2' variant='dark'>
            UI
          </Badge>
          <Badge className='mr-2' variant='info'>
            UX
          </Badge>
          <Badge className='mr-2' variant='success'>
            JMeter
          </Badge>
          <Badge className='mr-2' variant='warning'>
            Regex
          </Badge>
        </p>
      </div>
    </Container>
  );
};

export default new Content({
  Component: LuisFernandoRamos,
  title: "Luis Fernando Ramos",
  route: "luis-fernando-ramos",
  tags: [
    "junior",
    "QA",
    "tester",
    "stress",
    "sobrecarga",
    "concurrencia",
    "java",
    "ruby",
    "jmeter",
    "UI",
    "UX",
    "testing",
    "regex",
    "scrum",
    "TDD"
  ]
});
